import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { message } from 'antd';

import { hideModal } from '../../actions/modal';
import { getReferralsQuery } from '../../actions/records';
import LinkReferralModal from '../../components/modal/LinkReferralModal';

export const LinkReferralDialog = ({
  record,
  closeModal,
  refreshReferrals,
  pathname,
  search,
}) => {
  const navigateToRecord = (destinationRecord, query = '') => {
    if (!destinationRecord?.file_token) return;

    window.location.assign(`/app/view/${encodeURIComponent(destinationRecord.file_token)}${query}`);
  };

  const handleSuccess = async ({ followUpAction, destinationRecord } = {}) => {
    closeModal();

    if (followUpAction === 'go_to_record') {
      navigateToRecord(destinationRecord);
      return;
    }

    if (followUpAction === 'send_to_chart') {
      navigateToRecord(destinationRecord, '?sendToChart=true');
      return;
    }

    if (pathname === '/app/referred') {
      // `refreshReferrals` is a `crud()` thunk — it never rejects; it resolves with
      // `{ ...errorObject, error: true }` on failure. Inspect the resolved value.
      const result = await refreshReferrals(search || '?page=1');
      if (result?.error) {
        message.warning({ content: 'Inbox could not refresh. Reload to see the latest.' });
      }
    }
  };

  return (
    <LinkReferralModal
      hideModal={closeModal}
      onSuccess={handleSuccess}
      record={record}
    />
  );
};

LinkReferralDialog.propTypes = {
  record: PropTypes.shape({
    file_token: PropTypes.string,
    referral_entity_slug: PropTypes.string,
  }),
  closeModal: PropTypes.func.isRequired,
  refreshReferrals: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  search: PropTypes.string,
};

LinkReferralDialog.defaultProps = {
  record: null,
  pathname: '',
  search: '',
};

export default connect((state) => ({
  record: state.modal.modalType?.data?.record || null,
  pathname: state.router.location?.pathname,
  search: state.router.location?.search,
}), {
  closeModal: hideModal,
  refreshReferrals: getReferralsQuery,
})(LinkReferralDialog);
